var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hub-state-label"},[(_vm.loading)?_c('span',{staticClass:"hub-state-label__loader"},[_c('Icon',{attrs:{"name":"ring-white-gradient","group":"color","inline":""}})],1):_vm._e(),_c('span',{staticClass:"hub-state-label__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }